import { createRoot, type Root } from "react-dom/client";
import Setad from "../pages/Setad/Setad";
import "../index.css";
import "../pages/Setad/Setad.custom.css";

let root: Root | null = null;

function mount(element: HTMLElement) {
  if (root) return;
  root = createRoot(element);
  root.render(<Setad />);
}

function unmount() {
  root?.unmount();
  root = null;
}

window.ACADSetad = { mount, unmount };

function boot() {
  const element = document.getElementById("setad-root");
  if (element) mount(element);
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
else boot();
